import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {APP_INITIALIZER, Injectable, NgModule, PLATFORM_ID} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {RouterModule} from '@angular/router';
import {AppComponent} from './app.component';
import {AuthLayoutComponent} from './layouts/auth-layout/auth-layout.component';
import {NgbCalendar, NgbCalendarPersian, NgbDatepickerI18n, NgbDateStruct, NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {AppRoutingModule} from './app.routing';
import {ComponentsModule} from './components/components.module';
import {LogoutComponent} from './pages/logout/logout-layout.component';
import {FormRowModule} from './components/form-row/form-row.module';
import {JwtInterceptor} from './services/authentication/jwt.interceptor';
import {ErrorInterceptor} from './services/authentication/error.interceptor';
import {FormatTimePipe, RegisterComponent} from './pages/register/register.component';
import {ToastrModule} from 'ngx-toastr';
// import {CountdownModule} from 'ng2-date-countdown';
import {RECAPTCHA_LANGUAGE, RECAPTCHA_SETTINGS, RecaptchaFormsModule, RecaptchaModule, RecaptchaSettings, RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module} from 'ng-recaptcha';
import {RequestComponent} from './pages/payment/request/request.component';
import {VerifyComponent} from './pages/payment/verify/verify.component';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {ForgetPasswordComponent} from './pages/forget-password/forget-password.component';
import {OrderDetailComponent} from './pages/payment/order-detail/order-detail.component';
import {BrowserModule, Title, ɵgetDOM} from '@angular/platform-browser';
import {DOCUMENT, isPlatformBrowser, LocationStrategy, PathLocationStrategy} from '@angular/common';
import {LandingNavbarComponent} from './components/landing-navbar/landing-navbar.component';
import {LandingLayoutComponent} from './layouts/landing-layout/landing-layout.component';
import {UserLayoutComponent} from './layouts/user-layout/user-layout.component';
import {AdminLayoutComponent} from './layouts/admin-layout/admin-layout.component';
import {CrmLayoutComponent} from './layouts/crm-layout/crm-layout.component';
import {PsychologistLayoutComponent} from './layouts/psychologist-layout/psychologist-layout.component';
import {EditorLayoutComponent} from './layouts/editor-layout/editor-layout.component';
import {LoginComponent} from './pages/login/login.component';
import {NewLoginComponent} from './pages/authentication/login/login.component';
import {TransferHttpCacheModule} from '@nguniversal/common';
import {PrebootModule} from 'preboot';

const WEEKDAYS_SHORT = ['د', 'س', 'چ', 'پ', 'ج', 'ش', 'ی'];
const MONTHS = ['فروردین', 'اردیبهشت', 'خرداد', 'تیر', 'مرداد', 'شهریور', 'مهر', 'آبان', 'آذر', 'دی', 'بهمن', 'اسفند'];

@Injectable()
export class NgbDatepickerI18nPersian extends NgbDatepickerI18n {
  getWeekdayShortName(weekday: number) {
    return WEEKDAYS_SHORT[weekday - 1];
  }

  getMonthShortName(month: number) {
    return MONTHS[month - 1];
  }

  getMonthFullName(month: number) {
    return MONTHS[month - 1];
  }

  getDayAriaLabel(date: NgbDateStruct): string {
    return `${date.year}-${this.getMonthFullName(date.month)}-${date.day}`;
  }
}

@NgModule({
  imports: [
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    ComponentsModule,
    NgbModule,
    RouterModule,
    AppRoutingModule,
    HttpClientModule,
    FormRowModule,
    FormsModule,
    ReactiveFormsModule,
    ToastrModule.forRoot(),
    // CountdownModule,
    // RecaptchaModule,
    // RecaptchaFormsModule,
    FontAwesomeModule,
    // InViewportModule,
    BrowserModule.withServerTransition({appId: 'serverApp'}),
    TransferHttpCacheModule,
    RecaptchaV3Module
    // PrebootModule.withConfig({ appRoot: 'app-root' })


  ],
  declarations: [
    AppComponent,
    AuthLayoutComponent,
    LogoutComponent,
    LoginComponent,
    NewLoginComponent,
    RegisterComponent,
    RequestComponent,
    VerifyComponent,
    ForgetPasswordComponent,
    FormatTimePipe,
    OrderDetailComponent,
    LandingNavbarComponent,
    LandingLayoutComponent,
    UserLayoutComponent,
    AdminLayoutComponent,
    CrmLayoutComponent,
    PsychologistLayoutComponent,
    EditorLayoutComponent,
  ],
  exports: [
    FormatTimePipe,
  ],
  providers: [
//     {
// provide: APP_INITIALIZER,
//   useFactory: function(document: HTMLDocument, platformId: Object): Function {
//     return () => {
//       if (isPlatformBrowser(platformId)) {
//         const dom = ɵgetDOM();
//         // @ts-ignore
//         const styles: any[] = Array.prototype.slice.apply(dom.querySelectorAll(document, `style[ng-transition]`));
//         styles.forEach(el => {
//           // Remove ng-transition attribute to prevent Angular appInitializerFactory
//           // to remove server styles before preboot complete
//           el.removeAttribute('ng-transition');
//         });
//         document.addEventListener('PrebootComplete', () => {
//           // After preboot complete, remove the server scripts
//           setTimeout(() => styles.forEach(el => dom.remove(el)));
//         });
//       }
//     };
//   },
//   deps: [DOCUMENT, PLATFORM_ID],
//   multi: true,
// },
    {provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true},
    {provide: NgbCalendar, useClass: NgbCalendarPersian},
    {provide: NgbDatepickerI18n, useClass: NgbDatepickerI18nPersian},
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useValue: '6LeQS8EUAAAAAImQyVbjWKsJNQS_968-tWPCtGLM',
    },{
      provide: RECAPTCHA_LANGUAGE,
      useValue: 'fa',
    },
    {provide: LocationStrategy, useClass: PathLocationStrategy},
    Title

  ],
  bootstrap: [AppComponent]
})
export class AppModule {

}
